export const BOOKABLE_STATUS = {
    Bookable: 'Bookable',
    Unbookable: 'Unbookable'
}